import { Auth } from 'aws-amplify';
import api from 'helpers/api.lib';

/**
 * Documents
 * @default defaultData
 */

const defaultState = {}


/**
 * Fetch user info
 */
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_OK = 'FETCH_USER_OK';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';

function _fetchUser(callback) {
  api.fetchUserInfo().then(re => {
    return callback(null, re.data.data);
  }).catch(er => {
    return callback(er, null);
  });
}

export const fetchUser = () => {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      dispatch({ type: FETCH_USER });

      // To sure get currentUserCredentials correct on production environment when changing between minisites, we need to call twice
      let cred = await Auth.currentUserCredentials();
      cred = await Auth.currentUserCredentials();

      if (!cred || !cred.authenticated) {
        const er = 'Empty credential.';
        dispatch({
          type: FETCH_USER_FAIL,
          reason: er,
          data: { loading: false }
        });
        return reject(er);
      }

      const { authenticated, data } = cred;
      return _fetchUser((er, user) => {
        if (er) {
          dispatch({ type: FETCH_USER_FAIL, reason: er, data: { loading: false } });
          return reject(er);
        }

        dispatch({
          type: FETCH_USER_OK,
          reason: null,
          data: { ...user, authenticated, credentials: data.Credentials, loading: false }
        });
        return resolve(user);
      });
    });
  };
};


/**
 * Reducder
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_USER_OK:
      return { ...state, ...action.data };
    case FETCH_USER_FAIL:
      return { ...state, ...action.data };
    default:
      return state;
  }
}